var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGemini = function SvgGemini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M22.5 12.02A10.65 10.65 0 0 0 12.52 22h-.04a10.65 10.65 0 0 0-9.98-9.98v-.04A10.65 10.65 0 0 0 12.48 2h.04a10.65 10.65 0 0 0 9.98 9.98z"
  })));
};
export default SvgGemini;